import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { ContactService } from './../../services/contact.service';
import { SoaImageService } from './../../services/soa-image.service';
import { ProfessionalService } from './../../services/professional.service';
import { UserService } from './../../services/user.service';
import { EncrDecrService } from './../../services/encr-decr.service';
@Component({
  selector: 'app-view-professional',
  templateUrl: './view-professional.component.html',
  styleUrls: ['./view-professional.component.css']
})
export class ViewProfessionalComponent implements OnInit {

  user_id: any = '';
  company_id: any = '';
  APIKEY: any = '';
  autoload_check: any = '';
  model: any = {
  };
  submitForm: FormGroup;
  assign_fact: string;
  div1: boolean = true;
  div2: boolean = false;
  div3: boolean = true;
  isDisabled: boolean;

  professional_name: string;
  // contact_name: string;
  pro_unique_id: any;
  email: string;
  mobile_number: string;
  dob: string;
  ss_number: string;
  empl_type: string;
  address1: string;
  city: string;
  state: string;
  country: string;
  zip: string;
  status: string;
  address2: string;
  customerfiltter: object = [];
  professional_id: any;
  address_id: any;
  professional_data: any;
  submitted: boolean = false;
  professional_data1: any;
  tax_new_value: boolean;
  arrayOne(n: number): any[] {
    return Array(n);
  }
  n: number = 1;
  biiling_mode: boolean = false;
  biiling_read_only: boolean = false;
  btnDisable: boolean = false;


  constructor(private _contact: ContactService,
    private _router: Router,
    private toastr: ToastrService,
    private formbuilder: FormBuilder,
    private _soaImage: SoaImageService,
    private _user: UserService,
    private _activatedroute: ActivatedRoute,
    private _professional: ProfessionalService,
    private EncrDecr: EncrDecrService,) { }


  get dynamicFields() {
    return this.submitForm.controls["dynamicFields"] as FormArray;
  }
  ngOnInit() {
    this.user_id = localStorage.getItem('id'),
      this.company_id = localStorage.getItem('company_id');
    this.APIKEY = localStorage.getItem('APIKEY');
    this.autoload_check = 'yes';
    this.model = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id
    };
    this.model["terms"] = '';
    this.model["status"] = 'active';
    this.model["creditlimit"] = '0.00';
    this.model["assign_fact"] = 2;

    this.professional_name = '';
    // this.contact_name = '';
    this.pro_unique_id = '';
    this.email = '';
    this.mobile_number = '';
    this.dob = '';
    this.ss_number = '';
    this.empl_type = '';
    this.address1 = '';
    this.address2 = '';
    this.city = '';
    this.state = '';
    this.country = '';
    this.zip = '';
    this.status = '';


    this._activatedroute.params.subscribe(params => {
      this.professional_id = this.EncrDecr.get(localStorage.getItem('key'), params['id']);
      // this.professional_id = params['id'];
      //console.log(this.customer_id);
      // this.folder_id_e = params['id'];
      // this.folderid_encrypt = params['id'];
    });

    const professionaldata = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
      status: 'active',
      professional_id: this.professional_id,
    }


    this._professional.getprofessionaldata(professionaldata)
      .subscribe(
        res => {

          this.submitForm.get('professional_name').setValue(res.data.professional_name);
          this.submitForm.get('pro_unique_id').setValue(res.data.pro_unique_id);
          this.submitForm.get('mobile_number').setValue(res.data.phone);
          this.submitForm.get('email').setValue(res.data.email);
          this.submitForm.get('dob').setValue(res.data.dob);
          this.submitForm.get('ss_number').setValue(res.data.ss_number);
          this.submitForm.get('empl_type').setValue(res.data.empl_type);
          this.submitForm.get('status').setValue(res.data.status);

        },
      );


    const main1_driver = {
      module_id: this.professional_id,
      address_type: 'main',
      module_type: 'professional',
      APIKEY: this.APIKEY
    }
    this._contact.getContactaddressByid(main1_driver)
      .subscribe(

        addres => {

          this.address_id = addres.data.address_id;

          this.submitForm.get('address1').setValue(addres.data.address1);
          this.submitForm.get('address2').setValue(addres.data.address2);
          this.submitForm.get('country').setValue(addres.data.country);
          this.submitForm.get('city').setValue(addres.data.city);
          this.submitForm.get('state').setValue(addres.data.state);
          this.submitForm.get('zip').setValue(addres.data.zip);


        }, err => {
          console.log(err);
        }
      );





    this.submitForm = this.formbuilder.group({
      APIKEY: this.APIKEY,
      user_id: [localStorage.getItem('id')],
      company_id: [localStorage.getItem('company_id')],
      professional_name: this.professional_name,
      // contact_name: this.contact_name,
      pro_unique_id: this.pro_unique_id,
      email: this.email,
      mobile_number: this.mobile_number,
      dob: this.dob,
      ss_number: this.ss_number,
      empl_type: this.empl_type,
      address1: this.address1,
      address2: this.address2,
      city: this.city,
      state: this.state,
      country: this.country,
      zip: this.zip,
      status: this.status,
      dynamicFields: this.formbuilder.array([]),
      mobile_invoice_id: [],
      item_row: [],
      checkbox_value: [],
      autoload_check: '',
      professional_id: this.professional_id,
      address_id: this.address_id,

    });
    const dynamicFieldForm = this.formbuilder.group({
      id: [0],
      Selected: [false],
      professional_customer_id: [''],
      customer_id: [''],
      speciality: [''],
      tax_exempt: [],
      work_type: ['Regular'],
      cost_rate: [''],
      markup: [''],
      sale_rate: [''],
      pro_item_status: ['active'],
    });
    this.dynamicFields.push(dynamicFieldForm);

    const customerModal = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
      status: 'active',
    }


    this._professional.customerprofessionalListFilter(customerModal)
      .subscribe(
        res => {
          this.customerfiltter = res.data;
          //   console.log(this.customerfiltter);
        },
      );


    this.getprofessionalrelationdata();
    this.getprofessionalrelationdata1();

  }
  getprofessionalrelationdata() {
    const professionaldata1 = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
      status: 'active',
      professional_id: this.professional_id,
    }
    this._professional.getprofessionalrelationdata(professionaldata1)
      .subscribe(
        res => {
          // console.log(res.data);
          this.professional_data = res['data'];
          // console.log(this.professional_data);
          this.dynamicFields.removeAt(0);
          let i = 0;
          for (let item of this.professional_data) {
            if (item['tax_exempt'] == 1) {
              this.tax_new_value = true;
            } else {
              this.tax_new_value = false;
            }

            const dynamicFieldForm = this.formbuilder.group({

              id: [0],
              Selected: [false],
              professional_customer_id: [item['product_id']],
              customer_id: [item['customer_id']],
              speciality: [item['speciality']],
              tax_exempt: this.tax_new_value,
              work_type: [item['work_type']],
              cost_rate: [item['cost_rate']],
              markup: [item['markup']],
              sale_rate: [item['sale_rate']],
              pro_item_status: [item['status']],

            });
            this.dynamicFields.push(dynamicFieldForm);


            i++;
          }



        },
      );
  }
  getprofessionalrelationdata1() {
    const professionaldata1 = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
      status: 'active',
      professional_id: this.professional_id,
    }
    this._professional.getprofessionalrelationdata(professionaldata1)
      .subscribe(
        res => {
          // console.log(res.data);
          this.professional_data1 = res['data'];
        },
      );
  }

  //   onChange(divvalue,e)
  //  {

  // if(divvalue=='div1') {
  //   if(e.target.checked)
  // {
  // this.div2=true; this.div3=false; 
  // }
  // else  {
  //   this.div3=true;this.div2=false;
  // } 
  // }

  // if(divvalue=='div3'){
  //   if(e.target.checked){
  //     this.div3=true; this.div2=false;
  //   }else{
  //     this.div1=true;this.div2=false;
  //   }
  // }

  // }

  isNumberKey(evt) {
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode != 46 && charCode > 31
      && (charCode < 48 || charCode > 57))
      return false;

    return true;
  }





  public setBillingMode(value: boolean) {
    if (value == true) {
      this.model["same_as_check"] = 'yes';
      this.model["bill_address1"] = this.model["main_address1"];
      this.model["bill_address2"] = this.model["main_address2"];
      this.model["bill_country"] = this.model["main_country"];
      this.model["bill_city"] = this.model["main_city"];
      this.model["bill_state"] = this.model["main_state"];
      this.model["bill_zip"] = this.model["main_zip"];
      this.biiling_read_only = true;
    }
    else {
      this.model["same_as_check"] = 'no';
      this.model["bill_address1"] = '';
      this.model["bill_address2"] = '';
      this.model["bill_country"] = '';
      this.model["bill_city"] = '';
      this.model["bill_state"] = '';
      this.model["bill_zip"] = '';
      this.biiling_read_only = false;
    }
  }


  public assign_fact_NoStamp(value) {

    this.model["assign_fact"] = value;
    // console.log(this.model);

  }
  onlyAlpha_numberic(evt) {


    // Only ASCII charactar in that range allowed 
    var ASCIICode = (evt.which) ? evt.which : evt.keyCode
    //alert(ASCIICode);
    if ((ASCIICode >= 48 && ASCIICode <= 57) || (ASCIICode >= 65 && ASCIICode <= 90) || (ASCIICode >= 97 && ASCIICode <= 122) || ASCIICode == 38 || ASCIICode == 32 || ASCIICode == 39 || ASCIICode == 40 || ASCIICode == 41 || ASCIICode == 45 || ASCIICode == 44 || ASCIICode == 46)
      return true;
    return false;
  }


  onlyAlpha_numberic_address(evt) {

    // Only ASCII charactar in that range allowed 
    var ASCIICode = (evt.which) ? evt.which : evt.keyCode
    //alert(ASCIICode);
    if ((ASCIICode >= 48 && ASCIICode <= 57) || (ASCIICode >= 65 && ASCIICode <= 90) || (ASCIICode >= 97 && ASCIICode <= 122) || ASCIICode == 38 || ASCIICode == 32 || ASCIICode == 39 || ASCIICode == 40 || ASCIICode == 41 || ASCIICode == 45 || ASCIICode == 44 || ASCIICode == 46 || ASCIICode == 35)
      return true;
    return false;
  }


  addLine(index = 0) {
    const dynamicFieldForm = this.formbuilder.group({
      id: [''],
      Selected: [false],
      professional_customer_id: [''],
      customer_id: [''],
      speciality: [''],
      tax_exempt: [],
      work_type: ['Regular'],
      cost_rate: [''],
      markup: [''],
      sale_rate: [''],
      pro_item_status: ['Active'],
    });
    this.dynamicFields.push(dynamicFieldForm);


  }
  deleteRow(lessonIndex) {
    var delBtn = confirm(" Do you want to delete ?");
    if (delBtn == true) {

      var sss = new Array();

      i = 0;
      this.submitForm.value.dynamicFields.forEach(element => {
        if (element.Selected == true) {

          sss.push(i);

          if (element.mobile_invoice_id != '') {
            const itemdelete = {
              APIKEY: this.APIKEY,
              user_id: this.user_id,
              company_id: this.company_id,
              professional_id: this.professional_id,
              status: 'active',
              product_id: element.professional_customer_id,
            }

            this._professional.deleteProfessionalItem(itemdelete).subscribe(
              (response) => {

                if (response && response['status'] == true && response['data'] != '') {
                  this.toastr.success('Selected Item Deleted', 'success!');

                }
              });
          }

        }

        i++;
      });

      for (var i = sss.length - 1; i >= 0; i--) {

        this.dynamicFields.removeAt(sss[i]);
      }


      this.getprofessionalrelationdata1();

    }
  }

  checkProfessional() {
    var professional_name = this.submitForm.value.professional_name;
    var pro_unique_id = this.submitForm.value.pro_unique_id;

    const professionalModal = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
      professional_name: professional_name,
      pro_unique_id: pro_unique_id,
      professional_id: this.professional_id,
    }

    this._professional.checkDuplicate_professional(professionalModal)
      .subscribe(
        res => {
          if (res.status == false) {
            alert(res.message);
            return false;
          } else {
            this.addprofessional();
          }
        },
      );
  }

  get f() { return this.submitForm.controls; }
  addprofessional(status = 'Act') {
    this.submitted = true;
    this.isDisabled = true;
    var price_alt = 0;


    this.submitForm.get('dynamicFields').setValue(this.submitForm.value.dynamicFields);
    //console.log(this.submitForm.value.dynamicFields);
    var len = 0;
    this.submitForm.value.dynamicFields.forEach(element => {

      var customer_id: any = (element.customer_id);
      var speciality: any = element.speciality;
      var markup: any = element.markup;
      var sale_rate: any = element.sale_rate;
      var cost_rate: any = element.cost_rate;

      if (customer_id == '' || speciality == '' || sale_rate == '' || cost_rate == '' || sale_rate == 0 || cost_rate == 0) {
        price_alt++;
      }
      len++;
    })
    //console.log(price_alt);
    var alt = 0;
    for (var i = 0; i < len; i++) {
      var customer1 = $('#customer_id' + i).val();
      var speciality1 = $('#speciality' + i).val();
      var work_type1 = $('#work_type' + i).val();
      var cost_rate1 = $('#cost_rate' + i).val();
      var sale_rate1 = $('#sale_rate' + i).val();
      for (var jj = i + 1; jj < len; jj++) {
        var customer2 = $('#customer_id' + jj).val();
        var speciality2 = $('#speciality' + jj).val();
        var work_type2 = $('#work_type' + jj).val();
        var cost_rate2 = $('#cost_rate' + jj).val();
        var sale_rate2 = $('#sale_rate' + jj).val();

        if (customer1 == customer2 && speciality1 == speciality2 && work_type1 == work_type2) {
          alt++;
        }

      }
      if (cost_rate1 > sale_rate1 && cost_rate1 != sale_rate1) {
        alt++;
      }

    }
    // console.log("hhh", alt, price_alt, len);
    if (alt != 0 || price_alt > 0 || len == 0) {
      alert('Please enter all fields valid or you can delete that row.Below are the rules defined-\n\n 1.  The combination of customer,Speciality and Work type can not be empty . \n2.  Cost Rate & Sale Rate can not be 0 \n3.  Must have to enter atleast one row.\n4.  Duplicate records are not allowed.\n4.  Cost Rate should always be less or equal to Sale Rate');
      return false;
    }

    this._professional.addprofessionaldata(this.submitForm.getRawValue()).subscribe(
      (response) => {

        if (response && response['status'] == true) {

          this.toastr.success(response['data'], 'success!');
          this.isDisabled = false;

          //  window.location.reload();
        }
        this._router.navigate(['/professional/professional-list/active']);

      }, err => {
        console.log(err);
      }
    );


  }


  onlynumberprice(evt, fieldname) {
    var charCode = (evt.which) ? evt.which : evt.keyCode;

    if (charCode != 46 && charCode != 45 && charCode > 31
      && (charCode < 48 || charCode > 57))
      return false;

    return true;
  }



  priceachange(idd) {

    var markup: any = $("#markup" + idd).val();
    if (markup == '') {
      markup = 0;
    }
    var cost_rate: any = $("#cost_rate" + idd).val();
    if (cost_rate == '') {
      cost_rate = 0;
    }
    var princing_a1 = (((markup / 100) * cost_rate) + eval(cost_rate)).toFixed(2);
    var princing_a = princing_a1;
    // $("#sale_rate"+idd).val(princing_a); 

    var i = 0;
    this.submitForm.value.dynamicFields.forEach(element => {
      // console.log(element,'defined');
      var qty: any = parseFloat(element.qty) * 1;
      var price: any = parseFloat(element.price) * 1;
      if (i == idd) {
        element.sale_rate = princing_a;
      }
      i++;
    });
    this.submitForm.get('dynamicFields').setValue(this.submitForm.value.dynamicFields);
  }

  copy_pricing(idd) {
    var sale_rate: any = $("#sale_rate" + idd).val();
    var cost_rate: any = $("#cost_rate" + idd).val();

    var a_percent = sale_rate - cost_rate;
    if (a_percent == 0) {
      var final_a_percent = 0;
    }
    else if (a_percent < 0) {
      var final_a_percent = ((Math.abs(a_percent) / sale_rate) * 100);
    } else {
      var final_a_percent = ((Math.abs(a_percent) / sale_rate) * 100);
    }
    if (final_a_percent > 100)
      var f_a_per = final_a_percent - 100;
    else var f_a_per = final_a_percent;
    var result_a = Math.round(f_a_per * 100) / 100;
    var markup_percent: any = 0;
    var markup_percent1 = 0;
    if (cost_rate != 0)
      markup_percent1 = ((sale_rate - cost_rate) / cost_rate) * 100;
    markup_percent = markup_percent1.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];
    var i = 0;
    this.submitForm.value.dynamicFields.forEach(element => {
      var qty: any = parseFloat(element.qty) * 1;
      var price: any = parseFloat(element.price) * 1;
      if (i == idd) {
        element.markup = markup_percent * 1;
      }

      i++;

    });
    this.submitForm.get('dynamicFields').setValue(this.submitForm.value.dynamicFields);

  }

  copy_pricing_change(idd) {
    var markup: any = $("#markup" + idd).val();
    var cost_rate: any = $("#cost_rate" + idd).val();
    var sale_rate: any = 0;
    var number = cost_rate.replace('$', '');
    cost_rate = number.replace(/,/g, '');

    if (cost_rate == '') {
      sale_rate = '';
    } else {
      var princing_a1: any = 0;
      // console.log((markup / 100) * cost_rate + 'princing_e');
      princing_a1 = (((markup / 100) * cost_rate) + (cost_rate * 1)).toFixed(2);
      sale_rate = princing_a1;
    }

    $("#sale_rate" + idd).val(sale_rate);

    var i = 0;
    this.submitForm.value.dynamicFields.forEach(element => {
      var qty: any = parseFloat(element.qty) * 1;
      var price: any = parseFloat(element.price) * 1;
      if (i == idd) {
        element.sale_rate = sale_rate;
      }

      i++;

    });
    this.submitForm.get('dynamicFields').setValue(this.submitForm.value.dynamicFields);
    var a_percent = sale_rate - cost_rate;
    if (a_percent == 0)
      var final_a_percent = 0;
    else if (a_percent < 0)
      var final_a_percent = ((Math.abs(a_percent) / sale_rate) * 100);
    else
      var final_a_percent = ((Math.abs(a_percent) / sale_rate) * 100);
    if (final_a_percent > 100)
      var f_a_per = final_a_percent - 100;
    else var f_a_per = final_a_percent;
    var result_a = Math.round(f_a_per * 100) / 100;
  }




  copyprofessional_name(evt) {

    var professional_name: any = $("#professional_name").val();
    $("#pro_unique_id").val(professional_name);
    this.submitForm.get('pro_unique_id').setValue(professional_name);
  }




}

